// extracted by mini-css-extract-plugin
export default {"infoDiv":"InfoComponent_infoDiv__qt9j3","icon":"InfoComponent_icon__TOuRb","title":"InfoComponent_title__8aWFh"};